import * as types from 'stores/types/';

export function loginUser( data ) {
  return { type: types.LOGIN_USER, data };
}

export function updateUser( data ) {
  return { type: types.LOGIN_USER, data };
}

export function logoutUser() {
  return { type: types.LOGOUT_USER };
}



// WEBPACK FOOTER //
// ./stores/actions/common/user.js